import { PayloadAction, createAction, createReducer } from "@reduxjs/toolkit";

import { STORES } from "store/types";

import { DocumentCategory } from "./types";

export interface DocumentsState {
  category: DocumentCategory | null;
}

const initialState: DocumentsState = {
  category: null,
};

export const initialize = createAction(`${STORES.documents}/initialize`);

export const setCategory = createAction<DocumentCategory | null>(
  `${STORES.documents}/setCategory`
);

const documentsReducer = createReducer<DocumentsState>(
  initialState,
  (builder) => {
    builder.addCase(initialize, () => initialState);
    builder.addCase(
      setCategory,
      (state, action: PayloadAction<DocumentCategory | null>) => {
        state.category = action.payload;
      }
    );
  }
);

export default documentsReducer;
